import { Controller } from "@hotwired/stimulus"

/**
 * 연결된 컨트롤러
 * - VideoBlockLoad
 * - HighlightTranscript
 *
 * 이 컨트롤러의 역할
 * - 캐스트 form 제출에 의한 동작을 관리
 *   - form 제출 시, form 데이터를 서버로 전송
 *   - 성공시 VideoBlockLoad 에게 reload 명령
 *   - 성공시 HighlightTranscript 에게 변경된 cast 목록 전달
 */

// Connects to data-controller="edit-transcripts"
export default class extends Controller {
  static outlets = ["video-block-load", "highlight-transcript"]
  static targets = ["castListForm"]

  connect() {
  }

  castListFormTargetConnected(target) {
    const newCastList = JSON.parse(target.dataset.castList)

    if (this.hasHighlightTranscriptOutlet) {
      this.highlightTranscriptOutlet.castsValue = newCastList
    }
    if (this.hasVideoBlockLoadOutlet) {
      this.videoBlockLoadOutlet.reload()
    }
  }

  handleFocusout(event) {
    if (this.castListFormTarget.contains(event.relatedTarget)) {
      // 내부에서 발생한 focus 이동 이벤트는 무시
      return
    }
    this.castListFormTarget.requestSubmit()
  }

}
